import { TripType } from '@flysas-tech/book-value-stream-models';
import { Static, Object, Record, String, Literal, Union, Array, Optional } from '@sinclair/typebox';

import { FlightOffersMode } from '../../../constants';
import { StringEnumSchema } from '../../../utils/types';
import { BoundFlight, UpsellTable } from '../../flightOffers';
import { FareRules } from '../../sas-domain/fareRules';

export type RevenueFlightsResponse = Static<typeof RevenueFlightsResponse>;
export const RevenueFlightsResponse = Object({
  offerId: String(),
  tripType: Union([Literal(TripType.ONE_WAY), Literal(TripType.ROUND_TRIP)]),
  outboundFlights: Array(BoundFlight),
  inboundFlights: Optional(Array(BoundFlight)),
  fareRules: Record(String(), FareRules),
  upsellTable: UpsellTable,
});

export const RevenueFlightOffersModeParams = Object({
  origin: String(),
  destination: String(),
  cepId: Optional(String()),
});
export type RevenueFlightOffersModeParams = Static<typeof RevenueFlightOffersModeParams>;

export const RevenueFlightOffersModeResponse = Object({
  flightOffersMode: StringEnumSchema(FlightOffersMode),
});
export type RevenueFlightOffersModeResponse = Static<typeof RevenueFlightOffersModeResponse>;
